import styled from "styled-components";

interface ListProps {
  showFilter?: string;
  isFavoriteFilter?: boolean;
}

export const ListStyle = styled.ul<ListProps>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin-top: ${({ showFilter, isFavoriteFilter }) =>
    showFilter === "" && !isFavoriteFilter ? "" : "4.2rem"}; */
  margin-top: ${({ showFilter }) => (showFilter !== "" ? "4.2rem" : "")};
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;
